import { JsonSchemaValidator } from "@common/json-schema-validator";
import { BgHeight, BgUrl, BgWidth } from "../../interface";
import { bgHeight, bgUrl, bgWidth } from "../../schema";

export class MixerBgSetCmd {
  private static validation = JsonSchemaValidator.compile(
    MixerBgSetCmd.validationSchema()
  );

  readonly value: MixerBgSet;

  constructor(value: MixerBgSet) {
    this.value = JsonSchemaValidator.assert(MixerBgSetCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["bgUrl", "bgWidth", "bgHeight"],
      properties: {
        bgUrl,
        bgWidth,
        bgHeight
      },
      additionalProperties: false
    };
  }
}

interface MixerBgSet {
  bgUrl: BgUrl;
  bgWidth: BgWidth;
  bgHeight: BgHeight;
}
